(() => {
  const overlay = document.querySelector('#search-overlay');
  const headerInput = document.querySelector('#site-search');
  const input = document.querySelector('#search-overlay-input');
  const clear = document.querySelector('#search-clear');
  const close = document.querySelector('#search-close');
  const backdrop = document.querySelector('#search-backdrop');
  const empty = document.querySelector('#search-empty-state');
  const noResults = document.querySelector('#search-no-results');
  const results = document.querySelector('#search-results-content');
  const grid = document.querySelector('#search-products-grid');
  const count = document.querySelector('#search-products-count');
  const term = document.querySelector('#search-no-term');
  const viewAll = document.querySelector('#search-view-all');
  if (!overlay || !input) return;

  const root = window.Shopify?.routes?.root || '/';
  const money = (value) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(Number(value) || 0);
  const searchPage = (q) => `${root}search?q=${encodeURIComponent(q)}`;

  const open = () => { overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; setTimeout(() => input.focus(), 150); };
  const reset = () => { input.value = ''; clear.hidden = true; empty.hidden = false; noResults.hidden = true; results.hidden = true; grid.innerHTML = ''; };
  const closeSearch = () => { overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; reset(); };

  const render = (products, query) => {
    grid.innerHTML = products.map((product, index) => {
      const compare = Number(product.compare_at_price) > Number(product.price) ? ` <del>${money(product.compare_at_price)}</del>` : '';
      return `<a class="search-result-card" href="${product.url}" style="animation-delay:${Math.min(index * 40, 400)}ms"><img src="${product.featured_image?.url || ''}" alt="${product.title}" loading="lazy"><div class="search-result-info"><p class="search-result-brand">${product.vendor || ''}</p><p class="search-result-name">${product.title}</p><span class="search-result-price">${money(product.price)}${compare}</span></div></a>`;
    }).join('');
    if (viewAll) viewAll.href = searchPage(query);
    empty.hidden = true; noResults.hidden = true; results.hidden = false; count.textContent = `(${products.length})`;
  };
  const search = async (query) => {
    if (!query) { reset(); return; }
    const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`);
    if (!response.ok) throw new Error('search-failed');
    const data = await response.json();
    const products = data.resources?.results?.products || [];
    if (products.length) render(products, query);
    else { empty.hidden = true; results.hidden = true; noResults.hidden = false; term.textContent = `“${query}”`; }
  };
  let debounce;
  const onInput = () => {
    const query = input.value.trim();
    clear.hidden = !query;
    window.clearTimeout(debounce);
    debounce = window.setTimeout(() => { search(query).catch(() => { empty.hidden = true; results.hidden = true; noResults.hidden = false; term.textContent = `“${query}”`; }); }, 250);
  };

  headerInput?.addEventListener('focus', (event) => { event.target.blur(); open(); });
  headerInput?.addEventListener('click', () => { if (!overlay.classList.contains('is-open')) open(); });
  headerInput?.closest('form')?.addEventListener('submit', (event) => { event.preventDefault(); open(); });
  input.addEventListener('input', onInput);
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && input.value.trim()) { window.location.href = searchPage(input.value.trim()); }
  });
  document.querySelectorAll('.search-popular-tag').forEach((button) => button.addEventListener('click', () => { input.value = button.textContent.trim(); onInput(); input.focus(); }));
  clear.addEventListener('click', () => { reset(); input.focus(); });
  close.addEventListener('click', closeSearch);
  backdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch(); });
})();
